module.exports = __webpack_public_path__ + "images/knrm_small8cbe89c8a5c0a3150d7dcaaa31abc0c4.png";